import {
  trigger,
  state,
  style,
  transition,
  animate,
  group,
  query,
  stagger,
  keyframes,
} from '@angular/animations';

export const SlideInOutAnimation = [
  trigger('slideInOut', [
    state(
      'true',
      style({
        'max-height': '500px',
      }),
    ),

    state(
      'false',
      style({
        'max-height': '0px',
      }),
    ),

    transition('true => false', [
      group([
        animate(
          '600ms ease-in-out',
          style({
            'max-height': '0px',
          }),
        ),
      ]),
    ]),

    transition('false => true', [
      group([
        animate(
          '600ms ease-in-out',
          style({
            'max-height': '500px',
          }),
        ),
      ]),
    ]),
  ]),

  trigger('arrowInOut', [
    state(
      'true',
      style({
        transform: 'rotate(0deg)',
      }),
    ),

    state(
      'false',
      style({
        transform: 'rotate(-90deg)',
      }),
    ),

    transition('true => false', [
      group([
        animate(
          '600ms ease-in-out',
          style({
            transform: 'rotate(-90deg)',
          }),
        ),
      ]),
    ]),

    transition('false => true', [
      group([
        animate(
          '400ms ease-in-out',
          style({
            transform: 'rotate(0deg)',
          }),
        ),
      ]),
    ]),
  ]),

  trigger('cellInOut', [
    state(
      'true',
      style({
        borderBottomColor: '#ededed',
      }),
    ),

    state(
      'false',
      style({
        borderBottomColor: 'transparent',
      }),
    ),

    transition('true => false', [
      group([
        animate(
          '700ms ease-in-out',
          style({
            borderBottomColor: 'transparent',
          }),
        ),
      ]),
    ]),

    transition('false => true', [
      group([
        animate(
          '400ms ease-in-out',
          style({
            borderBottomColor: '#ededed',
          }),
        ),
      ]),
    ]),
  ]),
];
